module.exports = __webpack_public_path__ + "static/2_1_search-2_LV-c98c94b0af690e48ab94045df38ed91c.svg";